import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationKO from './locales/ko/translation.json';
import translationES from './locales/es/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  ko: {
    translation: translationKO,
  },
  es: {
    translation: translationES,
  },
};

i18n
  .use(LanguageDetector) // 브라우저 언어 감지
  .use(initReactI18next) // i18n 인스턴스를 react-i18next에 전달
  .init({
    resources,
    fallbackLng: 'en', // 기본 언어 설정
    debug: process.env.NODE_ENV === 'development', // 개발 모드에서 디버그 로그 활성화
    interpolation: {
      escapeValue: false, // React는 이미 XSS로부터 안전합니다.
    },
    detection: {
      // 감지 순서 및 방법 설정
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'], // 감지된 언어를 저장할 위치
    },
  });

export default i18n;
